import {
  faChevronLeft,
  faChevronRight,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { downloadAIPhoto } from '../actions';
import { makeSelectCurrentDownloadingPhotoURLs } from '../selectors';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
// import { openModal } from '~/containers/LoginModal/actions';
import DropdownMenu from '~/components/DropdownMenu';
import {
  makeSelectIsAuthenticated,
  makeSelectProfile,
} from '~/containers/AuthProvider/selectors';

const TOTAL_NUMBER_PHOTOS = 260;
const NUMBER_PHOTOS_PER_PAGE = 18;
const TOTAL_NUMBER_PAGES = parseInt(
  (TOTAL_NUMBER_PHOTOS + NUMBER_PHOTOS_PER_PAGE - 1) / NUMBER_PHOTOS_PER_PAGE,
);
// https://jp.static.photo-ac.com/assets/img/ai_model_v2/model_17.png
const baseURL = 'https://jp.static.photo-ac.com/assets/img/ai_model_v2';
const aiPhotos = [];
for (let iter = 1; iter <= TOTAL_NUMBER_PHOTOS; ++iter) {
  // const iterStr = `${iter}`.padStart(2, '0');
  aiPhotos.push(`${baseURL}/model_${iter}.png`);
}
const roles = Config.getRoles();

const styles = {
  iconLoading: {
    width: 22,
    marginRight: 7,
  },
};

@withI18next()
class AITopPhotos extends React.Component {
  constructor(props) {
    super(props);
    const currentPage = 1;
    const currentPhotos = this.getCurrentPhotos(currentPage);
    this.state = {
      currentPage,
      currentPhotos,
    };
  }

  getCurrentPhotos(currentPage) {
    const fromIndex = (currentPage - 1) * NUMBER_PHOTOS_PER_PAGE;
    const toIndex = currentPage * NUMBER_PHOTOS_PER_PAGE;
    return aiPhotos.slice(fromIndex, toIndex);
  }

  goToPage = (currentPage) => {
    const currentPhotos = this.getCurrentPhotos(currentPage);
    this.setState({ currentPage, currentPhotos });
  };

  handleChangePage = (event) => {
    const currentPage = parseInt(event.target.value, 10);
    this.goToPage(currentPage);
  };

  handleDownloadPhoto = (photoURL) => {
    const { downloadAIPhoto } = this.props;
    downloadAIPhoto(photoURL);
  };

  renderButtonDownload = (photoURL, isDownloading) => {
    const { t } = this.props;
    return (
      <button
        className={`btn btn-ac-primary btn-${Config.serviceType} btn-download-top-photo`}
        onClick={() => photoURL && this.handleDownloadPhoto(photoURL)}
        disabled={isDownloading}
      >
        {isDownloading ? (
          <FontAwesomeIcon icon={faSpinner} style={styles.iconLoading} pulse />
        ) : (
          t('Download')
        )}
      </button>
    );
  };

  renderButtonDownloadForFree = () => {
    const { t, lng } = this.props;
    return (
      <DropdownMenu
        className="button-download-top-photo-free"
        position="bottom"
        header={this.renderButtonDownload()}
      >
        <div
          className={`premium-hint-assets ${Config.getPrefixContent(
            'text-color',
          )}`}
          dangerouslySetInnerHTML={{
            __html: t('message_check_role_premium', {
              href: `${Config.getSiteURL()}/premium`,
            }),
          }}
        />
      </DropdownMenu>
    );
  };

  render() {
    const {
      t,
      currentDownloadingPhotoURLs,
      isAuthenticated,
      profile,
    } = this.props;
    const { currentPage, currentPhotos } = this.state;
    const blankPhotos = NUMBER_PHOTOS_PER_PAGE - currentPhotos.length;

    return (
      <div className="ai-top-photos">
        <div className="ai-photos-container">
          <div className="ai-photos">
            {currentPhotos.map((photoURL) => {
              const isDownloading = currentDownloadingPhotoURLs.includes(
                photoURL,
              );
              return (
                <div key={photoURL} className="ai-photo-container">
                  <img src={photoURL} className="ai-photo" />
                  <div className="ai-photo-overlay">
                    {isAuthenticated &&
                    (profile.role === roles.PREMIUM ||
                      profile.role === roles.PREMIUM_NO_ADS)
                      ? this.renderButtonDownload(photoURL, isDownloading)
                      : this.renderButtonDownloadForFree()}
                    <div className="photo-size">512 x 512px</div>
                  </div>
                </div>
              );
            })}
            {/* {new Array(blankPhotos).map((_, idx) => {
              return <div key={idx} className="ai-photo-container" />;
            })} */}
          </div>
        </div>
        <div className="ai-photos-pagination">
          <div>
            {t('total')}:
            <span className="number-pages">{TOTAL_NUMBER_PHOTOS}</span>
          </div>
          <div className="pagination-container">
            {t('page')}
            <input
              className="form-control input-page-number"
              type="number"
              min={1}
              max={TOTAL_NUMBER_PAGES}
              onChange={this.handleChangePage}
              value={currentPage}
            />
            / {TOTAL_NUMBER_PAGES}
            <button
              className={`btn btn-ac-primary btn-${Config.serviceType} btn-prev`}
              disabled={currentPage === 1}
              onClick={() => this.goToPage(currentPage - 1)}
            >
              <FontAwesomeIcon icon={faChevronLeft} style={{ width: '1em' }} />
            </button>
            <button
              className={`btn btn-ac-primary btn-${Config.serviceType} btn-next`}
              disabled={currentPage === TOTAL_NUMBER_PAGES}
              onClick={() => this.goToPage(currentPage + 1)}
            >
              <FontAwesomeIcon icon={faChevronRight} style={{ width: '1em' }} />
            </button>
          </div>
        </div>
        <style jsx global>
          {`
            .ai-top-photos {
              width: 100%;
              margin: 14px 0 28px 0;
            }
            .ai-photos-container {
              display: flex;
              justify-content: center;
              margin-right: 0;
            }
            .ai-photos {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
            }
            .ai-photos .ai-photo-container {
              position: relative;
              width: 300px;
              height: 300px;
              margin: 0 8px;
              margin-top: 14px;
              border-radius: 2px;
            }
            .ai-photos .ai-photo-container .ai-photo {
              width: 100%;
              height: auto;
              border-radius: 2px;
            }
            .ai-photos .ai-photo-container .ai-photo-overlay {
              opacity: 0;
              background: rgba(0, 0, 0, 0.6);
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-radius: 2px;
            }
            .ai-photos .ai-photo-container .ai-photo-overlay .photo-size {
              color: #fff;
              margin-top: 7px;
            }
            .ai-photos .ai-photo-container:hover .ai-photo-overlay {
              opacity: 1;
            }
            .ai-photos .button-download-top-photo-free .submenu-arrow-bottom {
              left: 25px;
            }
            .ai-photos .button-download-top-photo-free .submenu {
              position: absolute;
              right: 60px;
            }
            .ai-photos .button-download-top-photo-free .premium-hint-assets {
              min-width: 150px;
              min-height: 50px;
              font-size: 12px;
              text-align: center;
              padding: 7px;
            }
            .ai-photos .btn-download-top-photo {
              width: 140px;
              height: 40px;
              font-size: 18px;
            }

            .ai-photos-pagination {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: 7px 14px;
              background: #f2f3f4;
              margin-top: 14px;
            }
            .ai-photos-pagination .number-pages {
              font-weight: bold;
            }
            .ai-photos-pagination .pagination-container {
              display: flex;
              flex-direction: row;
              align-items: center;
              white-space: nowrap;
            }
            .ai-photos-pagination .input-page-number {
              width: 50px;
              text-align: center;
              padding: 6px 2px;
              border: 1px solid #f2f3f4;
              margin: 0 7px;
              border-radius: 2px;
            }
            .ai-photos-pagination .btn-prev,
            .ai-photos-pagination .btn-next {
              border: 1px solid #f2f3f4;
              height: 34px;
              margin-left: 7px;
              padding-top: 5px;
              padding-left: 10px;
              padding-right: 10px;
            }
            .ai-photos-pagination .btn-prev:hover,
            .ai-photos-pagination .btn-next:hover {
              color: #fff;
            }

            @media (max-width: 767px) {
              .ai-photos {
                justify-content: center;
              }
              .ai-photos .ai-photo-container {
                margin-left: 7px;
                margin-right: 7px;
              }
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
  profile: makeSelectProfile(),
  currentDownloadingPhotoURLs: makeSelectCurrentDownloadingPhotoURLs(),
});
const mapDispatchToProps = (dispatch) => ({
  // openLoginModal: () => dispatch(openModal()),
  downloadAIPhoto: (imageUrl) => dispatch(downloadAIPhoto(imageUrl)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AITopPhotos);
